import { render, staticRenderFns } from "./StockReceipts.vue?vue&type=template&id=2c5bc878"
import script from "./StockReceipts.vue?vue&type=script&lang=js"
export * from "./StockReceipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports